export default `
query ($sku:String!) {
  products(filter: {sku: {eq: $sku}}) {
    items {
      uid
      name
      sku
      product_top_category
			manufacturer_main_category
			category_type_main_txt
			category_type_manufacturer_txt

      custom_attributes {
        attribute_metadata {
          code
          data_type
          entity_type
          label
          uid
        }
        selected_attribute_options {
          attribute_option {
            label
          }
        }
      }
      
      categories {
        uid
        name
      }
      __typename
      ... on CustomizableProductInterface {
        options {
          title
          required
          sort_order
          option_id
          uid
          __typename
          ... on CustomizableRadioOption {
            radio: value {
              uid
              title
              price
              price_type
              sku
              sort_order
              option_type_id
            }
          }
          ... on CustomizableDropDownOption {
            dropdown: value {
              uid
              option_type_id
              price
              price_type
              sku
              sort_order
              title
            }
          }
          ... on CustomizableFieldOption {
            inputField: value {
              uid
              price
              price_type
              sku
              max_characters
              __typename
            }
          }
        }
      }
    }
  }
}`;
